@import "styles/variables/variables.scss";

$cs-unauth-content-max-width-sm: pxToRem(450px);

//NOTE: This may need to be ported to a reusable layout if ever we support an unauthenticated page
// that is not in the same side-by-side layout
.csa-unauth {
  height: 100vh;
  width: 100%;
  position: relative;

  .csa-unauth-form-section {
    width: 45%;
    padding: 6.5rem 7% 0;
    order: 2;
    z-index: 2;
    display: flex;
    flex-direction: column;

    .form-group {
      margin-bottom: 1.25rem;
    }
  }

  .csa-unauth-marketing {
    width: 55%;
    padding: 12.5rem 10% 5rem;
    order: 1;
    z-index: 1;

    .csa-unauth-marketing-jumbotron {
      .csa-unauth-marketing-lead {
        font-size: 1.125rem;
      }

      .csa-unauth-marketing-title {
        font-size: 3rem;
        line-height: 1.125;
        color: $brand-3;
        margin-bottom: 1.5rem;
      }

      .csa-unauth-marketing-body {
        font-size: 1.3125rem;
        line-height: 1.25;
      }
    }
  }

  .csa-unauth-form-button {
    width: 60%;
  }

  // Below this breakpoint the 2-column layout drops, so we hide the marketing panel entirely (e.g. widget
  // admin's login popup) instead of stacking it below the form, and vertically center the form-through-footer
  // content as a single block
  @include media-breakpoint-down(md) {
    min-height: 100vh;
    height: auto;
    flex-direction: column;
    justify-content: center; // centers the single visible flex item vertically

    .csa-unauth-form-section {
      width: 100%;
      padding: 3rem 2rem 1.5rem;

      .csa-unauth-form-content {
        width: 100%;
        max-width: $cs-unauth-content-max-width-sm;
      }
    }

    // hide the logo (which is already not visible due to white on white) and the "Did you know" panel —
    // it should never show below this breakpoint
    .csa-unauth-marketing,
    .csa-login-logo-wrapper {
      display: none;
    }

    .csa-unauth-form-button {
      width: 100%;
    }
  }
}
